import {createRoot} from 'react-dom/client'
import {App} from "./App.tsx";
import {registerSW} from 'virtual:pwa-register'
import {StrictMode} from "react";

registerSW({immediate: true})

document.addEventListener('keydown', function (e) {
	if ((e.ctrlKey || e.metaKey) && e.key === 's') {
		e.preventDefault();
	}
});

createRoot(document.getElementById('root')!).render(
	<StrictMode><App/></StrictMode>,
)
